export default function prepareDate(
	dateString: string,
	isShort: boolean = false,
	isLong: boolean = false,
) {
	const date = new Date(dateString);

	// Options for formatting the date DateTimeFormatOptions
	const options: Intl.DateTimeFormatOptions = {
		year: 'numeric',
		month: 'short',
		day: 'numeric',
		hour: isShort ? undefined : 'numeric',
		minute: isShort ? undefined : 'numeric',
		second: isLong ? 'numeric' : undefined,
		//   timeZoneName: 'short',
	};

	// Convert the date to a readable string
	return date.toLocaleDateString(undefined, options);
}

export function prepareDateHistory(dateString: string) {
	const date = new Date(dateString);
	// Custom formatting for the desired output
	const day = date.getDate().toString().padStart(2, '0'); // Day with leading zero
	const month = date.toLocaleString('en', { month: 'short' }); // Short month name (e.g., Oct)
	const year = date.getFullYear().toString().slice(-2); // Last two digits of the year (e.g., 24)
	return `${day}/${month}/${year}`;
}
